// extracted by mini-css-extract-plugin
module.exports = {"signBtn":"authMenu_signBtn__XQh0T","signIn":"authMenu_signIn__7kSpy","signUp":"authMenu_signUp__WlIV0"};